import { useMemo } from 'react';
import { useTimezoneDate } from '../useTimezoneDate';

export const useTimezoneMonth = (date: Date, timezone: string) => {
    const { month, year, timezoneOffset } = useTimezoneDate(date, timezone);

    const days = useMemo(() => {
        const localLastDayOfMonth = new Date(year, month, 0, 0, 0, 0, 0);
        const days = new Array(localLastDayOfMonth.getDate()).fill(null).map((_, index) => {
            const localStartOfDay = new Date(year, month - 1, index + 1, 0, 0, 0, 0);
            const startOfDay = new Date(localStartOfDay.getTime() + timezoneOffset);
            const localEndofDay = new Date(year, month - 1, index + 2, 0, 0, 0, 0);
            const endOfDay = new Date(localEndofDay.getTime() + timezoneOffset);
            return {
                from: startOfDay,
                to: endOfDay,
            };
        });
        return days;
    }, [year, month, timezoneOffset]);

    const nextMonth = useMemo(() => {
        const localNextMonth = new Date(year, month, 1, 0, 0, 0, 0);
        return new Date(localNextMonth.getTime() + timezoneOffset);
    }, [year, month, timezoneOffset]);

    const range = useMemo(() => {
        return {
            from: days[0].from,
            to: nextMonth,
        };
    }, [days, nextMonth]);

    const result = useMemo(() => {
        return {
            days,
            range,
        };
    }, [days, range]);

    return result;
};
